// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';

import history from '../../../../services/history';
import { getSearchData } from '../../../basket/store/selectors';
import * as basketActions from '../../../basket/store/actions';
import { InputWithButton } from '../../../../components';

class InputContainer extends Component {
  state = {};

  static propTypes = {
    isHomePage: PropTypes.bool,
    changeField: PropTypes.func,
    onSearch: PropTypes.func,
    search: PropTypes.object,
  };

  static defaultProps = {
    isHomePage: false,
    changeField: () => { },
    onSearch: () => { },
    search: null,
  };

  onChangeInput = (value, name) => {
    this.props.changeField(value, name);
  };

  onPress = () => {
    this.props.onSearch(this.props.search.EAN);
    history.push('/basket');
  }

  render() {
    const placeholder = 'Enter barcode, ISBN or EAN';

    const props = {
      isIndex: true,
      bottomHelper: true,
      value: this.props.search.EAN,
      onChangeInput: this.onChangeInput,
      onPress: this.onPress,
      name: 'EAN',
      isHomePage: this.props.isHomePage,
    };

    return (
      <MediaQuery minWidth={500}>
        {matches => (matches
          ? <InputWithButton
            {...props}
            placeholder={placeholder}
          />
          : <InputWithButton
            {...props}
            topHelper={placeholder}
          />)}
      </MediaQuery>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    search: getSearchData(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSearch: EAN => dispatch(basketActions.requestBasketSearch(EAN)),
    changeField: (value, name) => dispatch(basketActions.changeField(value, name)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InputContainer);
